import React, { useState, useEffect } from "react";
import AppDialog from "../../components/dialog/Dialog";
import { RootState } from "../../app/store";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@progress/kendo-react-tooltip";

const SearchMenu: React.FC = () => {
  const RemoveKey = ["dashboard", "usermanagement", "masters"];
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let menuList: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    menuList = JSON.parse(userResponseString).filter(
      (item: any) => !RemoveKey.includes(item.MenuKey),
    );
  } catch (error) {
    menuList = [];
  }

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredMenus, setFilteredMenus] = useState<any>(null);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const dialogName = useAppSelector(
    (state: RootState) => state.dialog.dialogName,
  );
  const navigate = useNavigate();

  useEffect(() => {
    setFilteredMenus(menuList);
  }, [menuList?.map((item: any) => item?.MenuID).join("-")]);
  // Handle Ctrl + K key press
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        e.key === "k" &&
        location.pathname !== "/login"
      ) {
        e.preventDefault();
        dispatch(openDialog("SearchMenuDialog"));
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      dispatch(closeDialog());
      setFilteredMenus([]);
    };
  }, []);
  useEffect(() => {
    if (searchTerm) {
      const lowercasedTerm = searchTerm.toLowerCase();
      setFilteredMenus(
        menuList.filter(
          (menu: any) => menu.MenuName.toLowerCase().includes(lowercasedTerm),
          // ||
          // menu.MenuKey.toLowerCase().includes(lowercasedTerm)
        ),
      );
    } else {
      setFilteredMenus(menuList);
    }
  }, [searchTerm]);

  const handleCloseDialog = () => {
    dispatch(closeDialog());
  };

  const highlightText = (text: string, searchTerm: string) => {
    if (!searchTerm) return text;
    const regex = new RegExp(`(${searchTerm})`, "gi");
    return text.split(regex).map((part, index) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span
          key={index}
          style={{ backgroundColor: "#fbababdd", color: "#000" }}
          className="highlight"
        >
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  const handleNavigate = (key: any) => {
    navigate(key);
    dispatch(closeDialog());
    setSearchTerm("");
  };
  return (
    <>
      {dialogName === "SearchMenuDialog" && location.pathname !== "/login" && (
        <AppDialog>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={handleCloseDialog}
          >
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "8px",
                height: "400px",
                width: "600px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h2>Search</h2>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search menu..."
                className="global-search-input"
              />
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  maxHeight: "70%",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  WebkitOverflowScrolling: "touch",
                }}
              >
                <ul>
                  {filteredMenus.map((menu: any) => (
                    <Tooltip
                      key={menu.key}
                      anchorElement="target"
                      position="top"
                      parentTitle={true}
                    >
                      <button
                        key={menu.MenuID}
                        className="global-search-button"
                        onClick={() => handleNavigate(menu.MenuKey)}
                      >
                        {highlightText(menu.MenuName, searchTerm)}
                      </button>
                    </Tooltip>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </AppDialog>
      )}
    </>
  );
};

export default SearchMenu;
